module.exports = __webpack_public_path__ + "static/media/white-chips.47e02181.png";